import * as React from "react";

function SvgFpLogoSmall(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg viewBox="0 0 581 125" ref={svgRef} {...props}>
      <g fillRule="nonzero" fill="none">
        <path
          d="M.238 75.164v-26.34c0-1.339 1.09-2.41 2.418-2.41h29.736a2.413 2.413 0 012.418 2.41v26.34c0 1.339-1.09 2.41-2.418 2.41H2.656a2.413 2.413 0 01-2.418-2.41z"
          fill="#EE5757"
        />
        <path
          d="M34.824 94.375v26.994a2.41 2.41 0 01-2.402 2.41l-29.737.269a2.42 2.42 0 01-2.447-2.411V94.36c0-1.34 1.09-2.41 2.418-2.41h29.736c1.343.014 2.432 1.1 2.432 2.425z"
          fill="#61DABF"
        />
        <path
          d="M91.91 2.619c0-1.34-1.088-2.41-2.416-2.41H2.656a2.413 2.413 0 00-2.418 2.41v26.98c0 1.338 1.09 2.41 2.418 2.41h86.822a2.413 2.413 0 002.418-2.41V2.618h.015z"
          fill="#EE5757"
        />
        <path
          d="M91.91 48.824c0-1.339-1.088-2.41-2.416-2.41H52.566a2.413 2.413 0 00-2.418 2.41v26.34c0 1.339 1.09 2.41 2.417 2.41H89.48a2.413 2.413 0 002.417-2.41v-26.34h.015z"
          fill="#61DABF"
        />
      </g>
    </svg>
  );
}

const FreshpaintLogoSmall = React.forwardRef(SvgFpLogoSmall);
export default FreshpaintLogoSmall;
